import { apiUrl, getByAxios } from "./axios.js"

export function getOptions(theSelect, params, success) {
  const axios = require('axios')
  let url = `${apiUrl}/${theSelect.data('endpoint')}`
  let injectedQueryParams = ""

  if (theSelect.data('before-submit')) {
    injectedQueryParams = eval(theSelect.data('before-submit'))()
  }

  if (theSelect.data('queryparams')) {
    url = `${url}?${theSelect.data('queryparams')}`
  }

  if (injectedQueryParams) {
    let paramsSeparator = "?"
    if (theSelect.data('queryparams')) { paramsSeparator = "&" }
    url = `${url}${paramsSeparator}${injectedQueryParams}`
  }

  let data = {term: (params.data) ? params.data.term : null }

  if (theSelect.data('endpoint')) {
    data['related_id'] = $(theSelect.data('related')).val()
  }
  
  if ((theSelect.data('related') && data['related_id'] || theSelect.data('relatedType') == 'populate_on_blank_parent') || !theSelect.data('related')) {
    getByAxios(axios, url, { params: data })
    .then(function (response) {
      success(response.data)
    })
  }
}
function beforeSubmit_addSelectedMembersToRequestFor_gt_match_list_t() {
  let selectedRecords = []
  selectedRecords = selectedRecords.concat(prepareSelectedRecords(`gt_match_list[t1]`))
  selectedRecords = selectedRecords.concat(prepareSelectedRecords(`gt_match_list[t2]`))
  return addSelectedRecordsToRequestByEls(selectedRecords)
}

function beforeSubmit_addSelectedTeamsToRequestFor_gt_tournament() {
  return addSelectedRecordsToRequest('gt_tournament[prize_places_attributes]')
}

function beforeSubmit_addSelectedTeamsToRequestFor_gt_tournaments_stage() {
  return addSelectedRecordsToRequest('gt_tournaments_stage[prize_places_attributes]')
}

function beforeSubmit_addSelectedMembersToRequestFor_gt_match_members() {
  return addSelectedRecordsToRequest('gt_match_list[members_attributes]')
}

function beforeSubmit_addSelectedPlayersToRequest_gt_teams_list() {
  return addSelectedRecordsToRequest('gt_teams_list[players_attributes]')
}

function beforeSubmit_addSelectedMembersToRequestFor_gt_tournaments_slots() {
  return addSelectedRecordsToRequest('gt_tournament[slots_attributes]')
}

function beforeSubmit_addSelectedMembersToRequestFor_member_replace() {
  return addSelectedRecordsToRequest('gt_tournament[teams_in_attributes]')
}

function beforeSubmit_addSelectedMembersToRequestFor_gt_match_game_csgo() {
  let selectedRecords = []
  selectedRecords = selectedRecords.concat(prepareSelectedRecords(`gt_match_game[t1_id_csgo]`))
  selectedRecords = selectedRecords.concat(prepareSelectedRecords(`gt_match_game[t2_id_csgo]`))
  return addSelectedRecordsToRequestByEls(selectedRecords)
}

function beforeSubmit_addSelectedMembersToRequestFor_gt_match_game_ow() {
  let selectedRecords = []
  selectedRecords = selectedRecords.concat(prepareSelectedRecords(`gt_match_game[t1_id_ow]`))
  selectedRecords = selectedRecords.concat(prepareSelectedRecords(`gt_match_game[t2_id_ow]`))
  return addSelectedRecordsToRequestByEls(selectedRecords)
}

function beforeSubmit_addSelectedTeamsToRequestFor_gt_tournaments_teams_status() {
  return addSelectedRecordsToRequest('gt_tournament[teams_in_attributes]')
}

function beforeSubmit_addSelectedPlayersToRequestFor_gt_tournaments_teams_status() {
  return addSelectedRecordsToRequest('gt_tournament[players_in_attributes]')
}

function beforeSubmit_addSiteToRequestFor_esn_banners_positions() {
  return `site=${$('#esn_banner_site').val()}`
}

function beforeSubmit_Members(el_id, name, withMarkedDestroyed) {
  let ids = beforeSubmit_ids(el_id, name, withMarkedDestroyed)
  return addSelectedRecordsToRequestByEls(ids)
}

function beforeSubmit_ids(el_id, name, withMarkedDestroyed) {
  let ids = []
  $(`input[name^='${el_id}']`).each( ( index, el ) => {
    if (el.id.endsWith(`_${name}`)) {
      if (withMarkedDestroyed) {
        if ($(el).closest('li').is(":visible")) {
          ids.push(el.value)
        } else {
          ids.push("-" + el.value)
        }
      } else {
        ids.push(el.value)
      }
    }
  })
  return ids
}

function beforeSubmit_matchStreams(withMarkedDestroyed=false) {
  return beforeSubmit_Streams("gt_match_list[streams_in_attributes]", 'sid', withMarkedDestroyed)
}

function beforeSubmit_Streams(el_id, name, withMarkedDestroyed) {
  let ids = beforeSubmit_ids(el_id, name, withMarkedDestroyed)
  return addSelectedRecordsToRequestByEls(ids)
}

function beforeSubmit_playerTeams(withMarkedDestroyed=false) {
  return beforeSubmit_Members("gt_player_list[teams_attributes]", 'team', withMarkedDestroyed)
}

function beforeSubmit_teamPlayers(withMarkedDestroyed=false) {
  return beforeSubmit_Members("gt_teams_list[players_attributes]", 'player', withMarkedDestroyed)
}

function beforeSubmit_tournamentTeams(withMarkedDestroyed=false) {
  return beforeSubmit_Members("gt_tournament[teams_in_attributes]", 'team', withMarkedDestroyed)
}

function beforeSubmit_tournamentPlayers(withMarkedDestroyed=false) {
  return beforeSubmit_Members("gt_tournament[players_in_attributes]", 'player', withMarkedDestroyed)
}

function beforeSubmit_matchPlayers() {
  let ids = []
  $(`select[name^='gt_match_list[members_attributes]']`).each( ( index, el ) => {
    ids = ids.concat(beforeSubmit_ids(`gt_match_list[members_attributes][${index}][players_attributes]`, 'player'))
  })
  return addSelectedRecordsToRequestByEls(ids)
}

function addSelectedRecordsToRequest(el_name) {
  let els = prepareSelectedRecords(el_name)
  return `selected_members_ids=${els.filter((v) => v != '').join('_')}`
}

function addSelectedRecordsToRequestByEls(els) {
  return `selected_members_ids=${els.filter((v) => v != '').join('_')}`
}

function prepareSelectedRecords(el_name) {
  let selectedRecords = []
  $(`select[name^='${el_name}']`).each( ( index, el ) => {
    let val = $(el).val()
    if (val && !$(el).is(":hidden")) {
      if (Array.isArray(val)) {
        for (let v of val) { selectedRecords.push(v) }
      } else {
        selectedRecords.push(val)
      }
    }
  })

  return selectedRecords
}

export function onChange(e, func_name) {
  eval(func_name)(e)
}

export function onSelect(e, func_name) {
  eval(func_name)(e)
}

export function onClear(e, func_name) {
  eval(func_name)(e)
}

function onSelect_tournamentPlayers(e) {
  onSelect_tournamentMembers(e)
}

function onSelect_tournamentTeams(e) {
  onSelect_tournamentMembers(e)
}

function onSelect_matchStreams(e) {
  onSelectBasicFunc(e)
}

function onSelect_tournamentMembers(e) {
  onSelectBasicFunc(e, 'template_with_icon')
  updateMembersCount(e.currentTarget.id)
}

function onSelect_playerTeams(e) {
  onSelectBasicFunc(e, 'template_with_icon')
}

function onSelect_matchPlayers(e) {
  onSelectBasicFunc(e, 'template_with_icon')
}

function onSelect_matchFragsPlayers(e) {
  onSelectBasicFunc(e, 'template_with_frags')
}

function onChange_setStageForm(e) {
  let el = e.currentTarget
  let value = $(el).select2('data')[0].form
  let target_el = $('#gt_tournaments_stage_form')
  if (value) {
    target_el.val(value)
    target_el.trigger('change')
  }
}

function onChange_setStageTypeByDiscipline(e) {
  let el = e.currentTarget
  let selected_value = el.value
  if (selected_value) {
    let target_el = $('#gt_tournaments_stage_form')
    if (selected_value == 100) {
      target_el.val('table')
    } else {
      target_el.val('group')
    }
    target_el.trigger('change')
  }
}

function onChange_matchPlayers(e) {
  let item = e.currentTarget.closest("ul.edit-teams-list")
  let ul_id = e.currentTarget.id.replace('_member_id','_players_ul')
  let ul_el = document.getElementById(ul_id)

  if (ul_el != null) {
    let inputs = ul_el.querySelectorAll("input[name*='_destroy']")
    if (inputs != null) {
      inputs.forEach(function(el) {
        el.value = 1
      })
    }

    let lis = ul_el.querySelectorAll("li")
    if (lis != null) {
      lis.forEach(function(el) {
        el.style.display = "none"
      })
    }
  }
}

function onSelect_teamPlayers(e) {
  onSelectBasicFunc(e, 'template_select_with_teams_count')
}

function onSelectBasicFunc(e, template_name=null) {
  e.preventDefault()
  let select2Obj = $(e.currentTarget)

  select2Obj.select2("close")

  let template_id = select2Obj.attr('id').replace('_select','_template')

  let content = template_name ? e.params.args.data[template_name] : e.params.args.data.text
  let content_id = e.params.args.data.id

  let template_content = document.getElementById(template_id).innerHTML
  template_content = template_content.replace(/TEMPLATE_CONTENT/g, content)
  template_content = template_content.replace(/TEMPLATE_ID/g, content_id)
  template_content = template_content.replace(/TEMPLATE_RECORD/g, new Date().valueOf())
  
  if (template_content.includes('TEMPLATE_TEAM_ID')) {
    let team_el_id = select2Obj.attr('id').replace('_players_select','_member_id')
    let team_id = $(document.getElementById(team_el_id)).val()
    template_content = template_content.replace(/TEMPLATE_TEAM_ID/g, team_id)
  }
  
  let ul_id = select2Obj.attr('id').replace('_select','_ul')
  document.getElementById(ul_id).insertAdjacentHTML('beforeend', template_content)
}

export function updateMembersCount(el_id) {
  const el = document.getElementById(el_id)

  // let more_id = el_id.replace('_select','_more')

  const label = $(`label[for=${el.id}]`)
  const original_label_text = label.text().split(' ')[0]
  let selected_ids_query = (el_id.includes('team')) ? beforeSubmit_tournamentTeams(true) : beforeSubmit_tournamentPlayers(true)

  getByAxios(require('axios'), `${el.dataset.onChangePath}.json?${selected_ids_query}`)
  .then(function (response) {
    let not_in_matches_member_ids = response.data.not_in_matches_member_ids
    let not_in_tournament_member_ids = response.data.not_in_tournament_member_ids
    let total = response.data.total
    label.html(`${original_label_text} <small>${total} (+${not_in_tournament_member_ids.length}, -${not_in_matches_member_ids.length})</small>`)
    // $(document.getElementById(more_id)).hide()
  })
}

function onChange_apiTournament(e) {
  if ($(e.currentTarget).select2('data')[0].id) {
    document.getElementById('search_tournament').value = $(e.target).select2('data')[0].id.split(',')[1]
  } else {
    document.getElementById('search_tournament').value = ''
  }
}

function onChange_parentStage(e) {
  const eng = $(e.currentTarget).select2('data')[0].eng
  if (eng != null) {
    $('#gt_tournaments_stage_eng').val(eng)
  }
}

function onChange_memberStatus(e) {
  const el = e.currentTarget

  const el_treplace = $(`#${el.id.replace('status','treplace')}`)

  if (el.value == 'replaced') {
    el_treplace.data('hidden', false)
    el_treplace.next(".select2-container").show()
  } else {
    el_treplace.data('hidden', true)
    let el_treplace_next = el_treplace.next(".select2-container").hide()
    el_treplace_next.next(".invalid-feedback").hide()
    el_treplace.val(null)
  }
}
